<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ForceMajeureProvision',
})
</script>
<template>
  <div class="force-majeure-provision">
    <NavBar :title="lang('不可抗力规则描述')" />
    <div class="box">
      <ul style="list-style-type: disc">
        <li>
          {{
            "The parcel is not delivered within the time limit due to the customer's own reasons (such as unreachable phone, unknown address, wrong address, etc.); "
          }}
        </li>
        <li>
          {{ ' National holidays;' }}
        </li>
        <li>
          {{ 'Due to force majeure factors, including two situations:' }}
        </li>
      </ul>
      <p>
        {{
          'a：caused by natural causes(such as floods, droughts, snowstorms, earthquakes, port cancellations, etc.);'
        }}
      </p>
      <p>
        {{ 'b：social reasons (such as war, strike, government ban, etc.);' }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup name="ForceMajeureProvision">
import NavBar from '@core/components/NavBar.vue'
import lang from '@/langs'
</script>

<style scoped lang="less">
.force-majeure-provision {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  .box {
    overflow-y: auto;
    flex: 1;
    padding: 20px;
    > p {
      font-size: 16px;
      margin-top: 12px;
      padding-left: 30px;
    }
    > ul {
      font-weight: bold;
      margin: 20px;
      > li {
        margin-top: 12px;
      }
    }
  }
}
</style>
